export default __webpack_public_path__ + "static/media/DNo.8-1.f5b86ca1.jpg";